import gsap from "gsap";

/**
 * CF7Controller class
 */
export default class CF7Controller {
    constructor() {
        /**
         *
         * @type {{thank_you: string, thank_you_close: string, forms: string}}
         */
        this.defaults = {
            //elements
            formWrappers: ".js-form-wrapper",
            form: ".wpcf7",
            thankYou: ".js-thankyou-msg",
            thankYouClose: ".js-close-msg",
        };

        this.formWrappers = document.querySelectorAll(this.defaults.formWrappers);
    }

    //region methods
    /**
     * CF7Controller class init method and init flag
     */
    init() {
        // console.log(this.formWrappers);

        if (this.formWrappers.length > 0) {
            this.formController();
        }
    }

    formController() {
        this.formWrappers.forEach((formWrapper) => {
            const form = formWrapper.querySelector(this.defaults.form);
            const msg = formWrapper.querySelector(this.defaults.thankYou);
            const close = formWrapper.querySelectorAll(this.defaults.thankYouClose);
            const button = formWrapper.querySelector("button[type=submit]");

            if (button) {
                button.addEventListener("click", () => {
                    button.style.pointerEvents = "none";
                    button.style.opacity = 0.5;
                });
            }

            if (form) {
                form.addEventListener(
                    "wpcf7submit",
                    () => {
                        button.style.pointerEvents = "";
                        button.style.opacity = "";
                    },
                    false,
                );

                form.addEventListener(
                    "wpcf7mailfailed",
                    () => {
                        button.style.pointerEvents = "";
                        button.style.opacity = "";
                    },
                    false,
                );

                form.addEventListener(
                    "wpcf7invalid",
                    () => {
                        button.style.pointerEvents = "";
                        button.style.opacity = "";
                    },
                    false,
                );

                form.addEventListener(
                    "wpcf7mailsent",
                    () => {
                        button.style.pointerEvents = "";
                        button.style.opacity = "";

                        if (msg != null) {
                            this.msgController(msg, close);
                        }
                    },
                    false,
                );
            }
        });
    }

    /**
     *
     * @param msg
     * @param close
     */
    msgController(msg, close) {
        gsap.to(msg, {
            autoAlpha: 1,
            onComplete: () => {
                gsap.to(msg, {
                    autoAlpha: 0,
                    delay: 15,
                });
            },
        });

        close.forEach((btn) => {
            btn.addEventListener("click", (ev) => {
                ev.preventDefault();

                gsap.to(msg, {
                    autoAlpha: 0,
                });
            });
        });
    }

    //endregion
}
